<template>
  <div class="detailed-info-block">
    <AlertIcon class="detailed-info-block__icon" />
    <div class="detailed-info-block__info" v-html="formatText(info)"></div>
  </div>
</template>

<script>
import { TextFormatter } from '@/shared/lib/string';
import { AlertIcon } from '@/shared/ui/icons';

const { formatText } = TextFormatter();

export default {
  props: {
    info: {
      type: String,
      default: '',
    },
  },
  components: { AlertIcon },
  methods: {
    formatText,
  },
};
</script>

<style lang="scss" scoped>
.detailed-info-block {
  display: flex;
  align-items: center;
  background-color: #ffffff;
  border: 1px solid #E5E5E7;
  border-radius: 8px;
  padding: 16px;

  &__info {
    padding-left: 10px;

    ::v-deep p {
      margin-bottom: 0 !important;
    }
  }
}
</style>
